import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7441f3fa"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "menu-container"
  }, null, -1);
});

var _hoisted_2 = {
  id: "menu-mobile"
};
var _hoisted_3 = {
  class: "d-flex p-0 m-0"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    id: "btn-upload-hd",
    title: "upload HD"
  }, null, -1);
});

var _hoisted_5 = [_hoisted_4];

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    id: "btn-split-view",
    title: "Split view to compare products"
  }, null, -1);
});

var _hoisted_7 = [_hoisted_6];

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    id: "btn-select-floor",
    title: "select floor"
  }, null, -1);
});

var _hoisted_9 = [_hoisted_8];

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    id: "btn-select-wall",
    title: "select wall"
  }, null, -1);
});

var _hoisted_11 = [_hoisted_10];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    id: "btn-zoom",
    title: "Zoom"
  }, null, -1);
});

var _hoisted_13 = [_hoisted_12];

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", {
    id: "btn-share",
    title: "Partager l'image"
  })], -1);
});

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    id: "btn-print",
    title: "Imprimer l'image"
  }, null, -1);
});

var _hoisted_16 = [_hoisted_15];
var _hoisted_17 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ShareModal = _resolveComponent("ShareModal");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("ul", _hoisted_3, [_createElementVNode("li", {
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.openModalEspace && _ctx.openModalEspace.apply(_ctx, arguments);
    })
  }, _hoisted_5), _createElementVNode("li", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.handleCompare({
        toggle: true
      });
    })
  }, _hoisted_7), _createElementVNode("li", {
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    function () {
      return _ctx.openModalFloor && _ctx.openModalFloor.apply(_ctx, arguments);
    })
  }, _hoisted_9), _createElementVNode("li", {
    onClick: _cache[3] || (_cache[3] = //@ts-ignore
    function () {
      return _ctx.openModalWall && _ctx.openModalWall.apply(_ctx, arguments);
    })
  }, _hoisted_11), _createElementVNode("li", {
    onClick: _cache[4] || (_cache[4] = //@ts-ignore
    function () {
      return _ctx.handleZoom && _ctx.handleZoom.apply(_ctx, arguments);
    })
  }, _hoisted_13), _createVNode(_component_ShareModal, null, {
    default: _withCtx(function () {
      return [_hoisted_14];
    }),
    _: 1
  }), _createElementVNode("li", {
    onClick: _cache[5] || (_cache[5] = //@ts-ignore
    function () {
      return _ctx.printImage && _ctx.printImage.apply(_ctx, arguments);
    })
  }, _hoisted_16), _createElementVNode("li", null, [_createElementVNode("a", {
    href: _ctx.sharingURL,
    id: "btn-download",
    title: "Télecharger l'image",
    target: "_blank",
    download: "result.jpeg"
  }, null, 8, _hoisted_17)])])])], 64);
}